const SUPPORTED_NETWORKS = {
    1: "mainnet",
    11155111: "sepolia",
    31337: "hardhat",
};
export function toNetwork(chainId) {
    if (!Object.hasOwn(SUPPORTED_NETWORKS, chainId))
        return undefined;
    return SUPPORTED_NETWORKS[chainId];
}
//# sourceMappingURL=network.js.map